/* React */
import React, { useRef } from "react";

/* React Redux */
import { useDispatch } from "react-redux";
import { setCurrentCohort } from "src/redux/features/custom-cohorts/customCohortsSlice";

/* Ionic */
import { IonItem, IonItemSliding } from "@ionic/react";

/* Components */
import ItemOptions from "src/components/insights/custom-cohorts/cohort-list/list-item/item-options/ItemOptions";

/* Stylesheet */
import styles from "./ListItem.module.scss";

/* Interfaces */
import { CustomCohortsProps } from "src/shared/interfaces/custom-cohorts/CustomCohorts";

const ListItem: React.FC<{
  index: number;
  item: CustomCohortsProps;
  editItem: string | undefined;
  handleEditItem: (id: string | undefined) => void;
}> = ({ index, item }) => {
  const slidingItemRef =
    useRef<HTMLIonItemSlidingElement | null>(null);
  const dispatch = useDispatch();

  const { id, name } = item;

  return (
    <IonItemSliding ref={slidingItemRef}>
      <IonItem
        style={{
          "--background":
            index % 2 === 0 ? "#ffffff" : "transparent",
        }}
        className={styles.list_item}
        lines="none"
        button
        onClick={() => {
          dispatch(setCurrentCohort({ id: id }));
        }}
      >
        <div className={styles.index}>{index + 1}</div>
        {name}
      </IonItem>
      <ItemOptions
        ref={slidingItemRef}
        item={item}
        dispatch={dispatch}
      />
    </IonItemSliding>
  );
};

export default ListItem;
